module.exports = __webpack_public_path__ + "img/banner_gpay.4f1595ba.png";